@if (shouldShow) {
  <app-clearance [clearance]="clearance" clearanceKey="mdoh">
  </app-clearance>
}
